import React, { useState, useCallback, useMemo } from "react";
import { Modal, Typography } from "@ann/web-components";
import { useMediaQueries } from "../../../../../../utils/mediaQueries";
import { SubtitleBodyContent } from "./DeleteDocumentModal.styled";

const DeleteDocumentModal = ({
  isOpen,
  onClose,
  onConfirm,
  documentTitle = "",
  isLoading = false,
  modalWidth = "900px",
  size = "medium",
}) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const { isMobile, isIpadAirPortrait, isIpadAirLandscape, isIpadProPortrait, isIpadProLandscape } =
    useMediaQueries();

  const isIpad = isIpadAirPortrait || isIpadAirLandscape || isIpadProPortrait || isIpadProLandscape;

  const responsiveWidth = useMemo(() => {
    if (isMobile) return "90%";
    if (isIpad) return "80%";
    return modalWidth;
  }, [isMobile, isIpad, modalWidth]);

  const loading = isLoading || isDeleting;

  const handleConfirm = useCallback(async () => {
    setIsDeleting(true);
    try {
      await onConfirm?.();
    } catch (err) {
    } finally {
      setIsDeleting(false);
      onClose?.();
    }
  }, [onConfirm, onClose]);

  const handleClose = useCallback(() => {
    if (!loading) onClose?.();
  }, [onClose, loading]);

  return (
    <Modal isOpen={isOpen} onClose={handleClose} width={responsiveWidth} size={size}>
      <Modal.Header />
      <Modal.Body>
          <Typography category="title" size="medium" weight="bold">
            {documentTitle ? (
              <>Are you sure you want to delete &quot;{documentTitle}&quot;?</>
            ) : (
              <>Are you sure you want to delete this document?</>
            )}
          </Typography>
          <SubtitleBodyContent>
          <Typography category="body" size="medium" weight="regular" color="body">
            This action cannot be undone.
          </Typography>
        </SubtitleBodyContent>
      </Modal.Body>
      <Modal.Actions align="center">
        <Modal.Button label="Cancel" onClick={handleClose} type="secondary" disabled={loading} />
        <Modal.Button
          label={loading ? "Deleting..." : "Delete"}
          onClick={handleConfirm}
          disabled={loading}
        />
      </Modal.Actions>
    </Modal>
  );
};

export default DeleteDocumentModal;
